import Vue from 'vue'
import App from './App.vue'

import './assets/tailwind.css'
import router from './router'
import store from './store'

import animated from 'animate.css'
import 'vue2-animate/dist/vue2-animate.min.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cookies from 'vue-cookies'
Vue.prototype.$cookies = cookies;
Vue.prototype.$store = store

import {
  Button,
  Select,
  Input,
  Message,
  Table,
  TableColumn,
  Progress,
  Option,
  Row,
  Col,
  Pagination,
  Divider,
} from 'element-ui';
Vue.use(ElementUI);
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Input.name, Input);
Vue.component(Message.name, Message);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Progress.name, Progress);
Vue.component(Option.name, Option);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Pagination.name, Pagination);
Vue.component(Divider.name, Divider);

Vue.use(animated)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
